const getCookie = require("./get-cookie");

module.exports = function () {
	return window.impersonatorId
		? "impersonation"
		: location.pathname === "/transaction"
		? "url_link"
		: "direct";
};
